import { Component, OnDestroy, OnInit, ViewEncapsulation, AfterContentInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GiantConfigService } from './services/config-service';
import { navigation } from 'src/app/shared/navigation';
import { UserRepository } from 'src/app/repositories/user/UserRepository';
import { GiantNavigationService } from './navigation/navigation.service';

@Component({
    selector: 'admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
    giantConfig: any;
    navigation: any;
    isNotLoginPage: boolean;
    status: boolean = false;
    mobileMedia: any = window.matchMedia("(max-width:700px)");
    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private _giantConfigService: GiantConfigService,
        private _userRepository: UserRepository,
        private _giantNavigationService: GiantNavigationService
    ) {
        // Set the defaults

        // this.navigation = navigation;
        // Set the private defaults

        this._unsubscribeAll = new Subject();

        if (this.mobileMedia.matches) {
            this.status = !status;
        }
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to config changes
        this._giantConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.giantConfig = config;
            });
        if (navigation[0].children.length == 0) {
            this._giantConfigService.setConfiguration();
        }
        if (localStorage.getItem('userToken') != null) {
            this.isNotLoginPage = true;
        }

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();


    }
    OuttoggleClick() {
        if (this.mobileMedia.matches) {
            this.status = !status;
        }
    }
    toggleSidebar() {
        this.status = !this.status;
    }
    reloadCurrentPage(){
        debugger
        if (this.mobileMedia.matches) {
            this.status = !status;
        }
    }
}
